import ptMessages from '../locales/pt_BR';

const PtLang = {
  messages: ptMessages,
  locale: 'pt-BR',
  name: 'Português',
};

export default PtLang;
